import { createContext } from 'react';

const PxcContext = createContext('pxc');

export default PxcContext;
